import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=1c382bf0&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatus.vue?vue&type=style&index=0&id=1c382bf0&prod&lang=scss"
import style1 from "./PaymentStatus.vue?vue&type=style&index=1&id=1c382bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c382bf0",
  null
  
)

export default component.exports